module.exports = __webpack_public_path__ + "img/afropaylogo.da7d6eb1.svg";